import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalAuthComponent } from './modal-auth.component';


@NgModule({
  declarations: [ModalAuthComponent],
  imports: [
    CommonModule
  ],
  exports: [ModalAuthComponent]
})
export class ModalAuthModule { }
